import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import router from "./util/routes.js";
import "./index.css";
import { GoogleOAuthProvider, GoogleLogin } from "@react-oauth/google";
import { GOOGE_CLIENT_ID } from "./config/apiConfig";
import "./util/testRoleHelper";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(

  <GoogleOAuthProvider clientId={GOOGE_CLIENT_ID}>
    <RouterProvider router={router} />
  </GoogleOAuthProvider>
);
